export enum AuthViewEnum {
    slider,
    userName,
    otp_verification,
    registeration,
    login,
    forget_pass
}